import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCalendarAlert(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={120}
      height={120}
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <g clipPath="url(#svg-calendar-alert-gradient-clip-path)">
        <circle
          cx={60.5}
          cy={60}
          r={50}
          stroke="url(#svg-calendar-alert-gradient)"
          strokeWidth={20}
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          d="M53.917 49.167v-3.334m14.166 3.334v-3.334m-14.166 10h14.166M52.25 75h17.5a5 5 0 0 0 5-5V54.167a5 5 0 0 0-5-5h-17.5a5 5 0 0 0-5 5V70a5 5 0 0 0 5 5Z"
        />
      </g>
      <rect width={39} height={39} x={1} y={10.5} fill="#0D2B57" rx={19.5} />
      <rect width={39} height={39} x={1} y={10.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.51}
        d="M20.5 24v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="svg-calendar-alert-gradient"
          x1={60.5}
          x2={60.5}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="svg-calendar-alert-gradient-clip-path">
          <rect width={100} height={100} x={10.5} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCalendarAlert);
export default ForwardRef;
